import StandardMenu from './StandardMenu';
export const standardMenuProps = StandardMenu.propTypes;
export default StandardMenu;
